import { Link } from "react-router-dom";
import { MapPin, Coins, Lock, Unlock, BadgeCheck, ArrowUpRight } from "lucide-react";
import { fmtMoney, fmtDate } from "@/lib/api";

export const AccessBadge = ({ access, cost }) =>
  access ? (
    <span className="inline-flex items-center gap-1 text-xs font-medium text-emerald-600 dark:text-emerald-400"><Unlock className="h-3.5 w-3.5" />{access === "credits" ? "Unlocked" : "Via subscription"}</span>
  ) : (
    <span className="inline-flex items-center gap-1 text-xs font-semibold text-amber-700 dark:text-amber-400"><Coins className="h-3.5 w-3.5" />{cost} credits</span>
  );

export default function LeadCard({ lead, delay = 0 }) {
  return (
    <Link to={`/app/leads/${lead.id}`} data-testid={`lead-card-${lead.id}`} style={{ animationDelay: `${delay}ms` }}
      className="group bg-card rounded-xl border p-5 sm:p-6 flex flex-col fade-up hover:border-primary/40 hover:shadow-md transition-[border-color,box-shadow]">
      <div className="flex items-center justify-between gap-2">
        <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-primary truncate">{lead.category}</span>
        <BadgeCheck className="h-4 w-4 text-emerald-500 shrink-0" />
      </div>
      <h3 className="font-display font-semibold text-base mt-2 leading-snug line-clamp-2 group-hover:text-primary transition-colors">{lead.title}</h3>
      <p className="text-sm text-muted-foreground mt-2 line-clamp-2">{lead.description}</p>
      <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{[lead.city, lead.country].filter(Boolean).join(", ")}</span>
        {lead.industry && <span>{lead.industry}</span>}
        <span>{fmtDate(lead.published_at)}</span>
      </div>
      <div className="mt-5 pt-4 border-t flex items-center justify-between">
        <div>
          <p className="text-[11px] text-muted-foreground uppercase tracking-wider">Budget</p>
          <p className="font-display font-bold">{fmtMoney(lead.budget, lead.currency)}</p>
        </div>
        <div className="flex items-center gap-2">
          {lead.access ? <AccessBadge access={lead.access} /> : <span className="inline-flex items-center gap-1 text-xs text-muted-foreground"><Lock className="h-3.5 w-3.5" /></span>}
          {!lead.access && <AccessBadge access={null} cost={lead.credit_cost} />}
          <ArrowUpRight className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" />
        </div>
      </div>
    </Link>
  );
}
